import {
  ITwoUpRoutingFields,
  SpecificLocaleFields,
} from "~/@types/generated/contentful";
import { RoundedCta } from "../ctas";
import { Arrow } from "../icons";
import { ContentfulCenteredImage, ForcedAspectRatio } from "../shared";
import clsx from "clsx";
import useIsMobile from "../utils/useIsMobile";

export type TwoUpRoutingProps = {
  fields: SpecificLocaleFields<ITwoUpRoutingFields>;
};

export default function TwoUpRouting({ fields }: TwoUpRoutingProps) {
  const isMobile = useIsMobile();
  const desktopColumnClass =
    fields.routes.length > 0
      ? `col-span-${12 / fields.routes.length}`
      : "col-span-6";
  const usePortraitImages = fields.imageOrientationIsPortrait && !isMobile;

  return (
    <section
      data-content-type="twoUpRouting"
      data-module-title={fields.moduleTitle}
      style={{
        backgroundColor: fields.colorPalette?.fields.backgroundColor,
        color: fields.colorPalette?.fields.fontColor,
      }}
    >
      <div className={clsx("tbi-tablet-grid", !isMobile && "py-20")}>
        {fields.routes &&
          fields.routes.map((route) => (
            <div
              key={route.sys.id}
              className={clsx(
                "flex h-full flex-col",
                isMobile ? "col-span-full my-6" : desktopColumnClass,
              )}
            >
              {route.fields.image && (
                <ForcedAspectRatio
                  className="w-full"
                  ratio={usePortraitImages ? [3, 4] : [16, 9]}
                >
                  <ContentfulCenteredImage
                    className="h-full w-full"
                    image={route.fields.image.fields ?? ""}
                  />
                </ForcedAspectRatio>
              )}
              {route.fields.heading && (
                <h4 className="mt-6">{route.fields.heading}</h4>
              )}
              {route.fields.body && <p className="mt-6">{route.fields.body}</p>}
              <div className={clsx(!isMobile && "mt-auto")}>
                {route.fields.cta && (
                  <RoundedCta
                    className="mt-6"
                    to={route.fields.cta.fields.buttonUrl}
                    label={route.fields.cta.fields.buttonText}
                    kind={route.fields.cta.fields.type}
                    icon={<Arrow />}
                    custom={route.fields.cta.fields.colorPalette?.fields}
                  />
                )}
              </div>
            </div>
          ))}
      </div>
    </section>
  );
}
